import { useQuery } from "react-query";
import { getHeaderAuthBearerToken } from "utils/requests/auth";
import { webApi } from "services/api/config";

export function useQueryGetAllScholarshipsRecesses() {
  return useQuery(["useGetAllScholarshipsRecesses"], async () => {
    const { data } = await webApi.get(`api/ScholarshipsRecesses`, {
      headers: {
        Authorization: getHeaderAuthBearerToken(),
      },
    });

    return data;
  });
}
